import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { AccessDeniedScreen } from '@/app/gates/index.js';

export const Route = createFileRoute('/access-denied')({
  component: AccessDeniedPage,
});

/**
 * /access-denied — where an authorized call that came back 403 sends the user.
 * A 403 from the token exchange never gets this far: AuthGate renders the same
 * screen in place, since there is no session to route with.
 */
function AccessDeniedPage(): JSX.Element {
  return <AccessDeniedScreen />;
}
